import { FC } from "react"
import { IStudent } from "types"
import { useTableModel } from 'utils/tableModels/useRtiInterventionsTableModel'
import { useGET_rtiInterventionsQuery } from 'redux/api/rtiApi'
import MainTable from "components/organisms/tables/MainTable"
import { Tooltip, Button } from "@mui/material"
import { t } from "i18next"
import { useNavigate } from "react-router-dom"
import { Add } from "@mui/icons-material"
import { removeEmpty } from "utils/helpers"


interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const RtiInterventionList: FC<IProps> = ({ student }) => {

    const navigate  =  useNavigate()
    
    const filters = {
        student: student.student_profile_id
    }

    return <> 
       <MainTable
            useTableModel={useTableModel}
            getTableData={ useGET_rtiInterventionsQuery}
            filters={removeEmpty(filters)}
            header={<div style={{ textAlign: 'right', paddingBottom: '10px' }}>

                  <Tooltip title={`${t('common.add-intervention')}`} arrow placement='top'>
                    <Button
                        variant='contained'
                        color='success'
                        aria-haspopup='true'
                        onClick={() => navigate(`/rti-interventions/add`)}
                        disableElevation
                        sx={{ 
                            lineHeight: '1rem'
                        }}
                    >
                        <Add />                         
                        <span>{`${t('common.add-intervention')}`}</span>
                    </Button>
                </Tooltip>
                
            </div>}
       />    
    </>
}
export default RtiInterventionList